module.exports = __webpack_public_path__ + "static/img/h-bgimg.ab0e315.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h-bgimg.png
// module id = QhUU
// module chunks = 1